<template>
  <div>
    <form-section :title="$t('Integrations_Settings_BasicSettings')">
      <rest-form-item
        :label="$t('Integrations_Field_Name')"
        :hint="$t('Integrations_Field_Name_Description')"
        prop="name"
      >
        <el-input
          v-model="model.name"
          :placeholder="$t('Integrations_Field_Name')"
          :disabled="isEditPage"
        />
      </rest-form-item>
      <rest-form-item
        :label="$t('Integrations_Field_Tenant_Id')"
        prop="params.tenant_id"
      >
        <el-input
          v-model.number="model.params.tenant_id"
          :disabled="isEditPage"
        />
      </rest-form-item>
    </form-section>

    <form-section :title="$t('Integrations_Settings_ConnectionSettings')">
      <rest-form-item
        :label="$t('Integrations_Field_Username')"
        prop="params.username"
      >
        <el-input v-model="model.params.username" :disabled="isEditPage" />
      </rest-form-item>

      <rest-form-item
        :label="$t('Integrations_Field_Password')"
        prop="params.password"
      >
        <el-input
          v-model="model.params.password"
          type="password"
          :disabled="isEditPage"
        />
      </rest-form-item>

      <rest-form-item :label="$t('Integrations_Field_Host')" prop="params.host">
        <el-input v-model="model.params.host" :disabled="isEditPage" />
      </rest-form-item>
    </form-section>
    <form-section
      :title="$t('Integrations_Gig_Identifier_Mapping_Title')"
      :description="$t('Integrations_Gig_Identifier_Mapping_Description')"
    >
      <el-select v-model="model.params.id_mapping" :disabled="isEditPage">
        <el-option
          v-for="option in identifierOptions"
          :key="option.value"
          :value="option.value"
          :label="option.label"
        />
      </el-select>
    </form-section>
  </div>
</template>

<script>
import FormSection from '@/common/components/form/FormSection'
import RestFormItem from '@/common/components/rest/RestFormItem'

export default {
  name: 'GigSettings',
  components: {
    RestFormItem,
    FormSection
  },

  props: {
    model: {
      type: Object,
      required: true
    }
  },

  mounted() {
    if (!this.model.params.hasOwnProperty('id_mapping')) {
      this.$set(this.model.params, 'id_mapping', 'user_id')
    }

    if (!this.model.params.hasOwnProperty('approved')) {
      this.$set(this.model.params, 'approved', 0)
    }
  },

  data() {
    return {
      rules: {
        name: {
          required: true,
          message: this.$t('RestForm_FieldIsRequired')
        },
        params: {
          username: [
            {
              required: true,
              message: this.$t('RestForm_FieldIsRequired')
            }
          ],
          password: [
            {
              required: true,
              message: this.$t('RestForm_FieldIsRequired')
            }
          ],
          host: [
            {
              required: true,
              message: this.$t('RestForm_FieldIsRequired')
            }
          ],
          tenant_id: [
            {
              required: true,
              message: this.$t('RestForm_FieldIsRequired')
            },
            {
              type: 'integer',
              message: this.$t('RestForm_ValueShouldBeANumber')
            }
          ]
        }
      },
      identifierOptions: [
        {
          value: 'user_id',
          label: this.$t('Integrations_Gig_Identifier_Mapping_User_Id')
        }
      ]
    }
  },

  computed: {
    isEditPage() {
      return !!this.$route.query.id
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/integrations/types/gig/GigSettings.vue